import { useState } from "react";
import { Languages, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Account-level email language preference (receipts, future waivers).
 * Does NOT translate the app UI — only which language transactional emails
 * are sent in. Shared by both the Owner (Team.jsx) and Student profile pages. */
export default function LanguagePreference() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const current = user?.preferred_language || "en";

  const setLang = async (lang) => {
    if (lang === current || busy) return;
    setBusy(true);
    try {
      await api.patch("/auth/preferences", { preferred_language: lang });
      setUser((prev) => (prev ? { ...prev, preferred_language: lang } : prev));
    } catch (_) {
      // no-op — button just stays on the previous selection
    }
    setBusy(false);
  };

  return (
    <div className="card p-4 flex items-center gap-4" data-testid="language-preference-card">
      <Languages size={18} style={{ color: "var(--green)" }} />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-[14px] uppercase tracking-tight">Email language</div>
        <div className="label-tiny mt-0.5" style={{ textTransform: "none", letterSpacing: 0, fontSize: 11 }}>
          Receipts and other account emails will be sent in this language
        </div>
      </div>
      <div className="flex gap-1.5 shrink-0">
        {["en", "es"].map((lang) => (
          <button
            key={lang}
            onClick={() => setLang(lang)}
            disabled={busy}
            className="pill"
            data-testid={`lang-option-${lang}`}
            style={
              current === lang
                ? { background: "var(--green-bg)", color: "var(--green)", border: "1px solid var(--green-border)" }
                : { background: "transparent", color: "var(--text-dim)", border: "1px solid var(--border)" }
            }
          >
            {current === lang && <Check size={11} />} {lang === "en" ? "English" : "Español"}
          </button>
        ))}
      </div>
    </div>
  );
}
